import { Pagination as AntPagination } from "antd";
import React, { PropsWithChildren } from "react";
import styles from "./Pagination.module.scss";
import { IPaginationProps } from "./Pagination.props";
import { usePaginationControl } from "./usePaginationControl";
import classNames from "classnames";

function Pagination<T>({ ...props }: PropsWithChildren<IPaginationProps<T>>) {
  // dev.log("render: Pagination");

  const control = usePaginationControl(props);

  function isShowPageSize(): boolean {
    if (typeof props.showPageSize !== "undefined") {
      return props.showPageSize;
    }
    return true;
  }

  return (
    <div className={classNames(styles.paginations, props.className)}>
      <AntPagination
        onShowSizeChange={(curr, size) => control.setPageSize(size)}
        onChange={(page) => control.setCurrentPage(page)}
        pageSize={control.pageSize}
        defaultCurrent={1}
        current={control.currentPage}
        total={control.total}
        showSizeChanger={isShowPageSize()}
        hideOnSinglePage
      />
    </div>
  );
}

export default React.memo(Pagination) as typeof Pagination;
